/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

// Add only if a library requires Node globals:
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
import * as process from 'process';
(window as any).process = process;
